import { createMulticastServiceType } from '@tv2-player/service-container/src/serviceContainer';
import { TimestampedVCREvent } from './vcr';

export interface VcrCollector {
  collect(e: TimestampedVCREvent, sessionId: string): void;
}

export const VcrCollector = createMulticastServiceType<VcrCollector>();
